<div>
  @if (unauthorizedMessage) {
    <div class="alert alert-warning mt-3" role="alert">
      {{ unauthorizedMessage }}
    </div>
  }
  <div class="oAuthApi mt-4 mb-4">
    <button type="button" class="signin-btn-google" (click)="openOAuthApi()">
      <div class="icon google">
        <div class="icon-google xs"></div>
        <b>&nbsp;&nbsp;&nbsp;Login with your Medispring Google account</b>
      </div>
    </button>
</div>
